var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 31,
    viewBox: "0 0 37 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2196 8.296V4.6L18.5236 13.796L3.82756 4.6V8.296L18.5236 17.404L33.2196 8.296ZM33.2196 0.903999C34.2169 0.903999 35.0676 1.27067 35.7716 2.004C36.4756 2.73733 36.8276 3.60267 36.8276 4.6V26.6C36.8276 27.5973 36.4756 28.4627 35.7716 29.196C35.0676 29.9293 34.2169 30.296 33.2196 30.296H3.82756C2.83023 30.296 1.97956 29.9293 1.27556 29.196C0.57156 28.4627 0.21956 27.5973 0.21956 26.6V4.6C0.21956 3.60267 0.57156 2.73733 1.27556 2.004C1.97956 1.27067 2.83023 0.903999 3.82756 0.903999H33.2196Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.447fdf011a1c55404f1b1eeacdeba18d.svg";
export { ForwardRef as ReactComponent };